import { useCallback, useMemo } from "react";
import buildContextAgentAttentionMessage, {
  isContextAgentAttentionMessageReady,
} from "./buildContextAgentAttentionMessage";
import ContextAgentAttentionBubble from "./ContextAgentAttentionBubble";
import useContextAgentAttentionBubble from "./useContextAgentAttentionBubble";

export function ContextAgentLauncherBubble({
  bubbleVisible,
  bubbleExiting,
  attentionMessage,
  placement,
  onBubbleClick,
  onBubbleDismiss,
  onBubbleAnimationEnd,
}) {
  if (!bubbleVisible) {
    return null;
  }

  return (
    <ContextAgentAttentionBubble
      message={attentionMessage}
      placement={placement}
      exiting={bubbleExiting}
      onClick={onBubbleClick}
      onDismiss={onBubbleDismiss}
      onAnimationEnd={onBubbleAnimationEnd}
    />
  );
}

/**
 * Shared attention greeting + bubble state for sidebar and widget launchers.
 */
export default function useContextAgentLauncherAttention(registration, { open, setOpen }) {
  const scopeKey = registration ? registration.scopeId ?? registration.agentName : null;

  const attentionMessage = useMemo(
    () =>
      registration
        ? buildContextAgentAttentionMessage({
            agentName: registration.agentName,
            scopeLabel: registration.scopeLabel,
            scopeId: registration.scopeId,
            attentionMessage: registration.attentionMessage,
          })
        : "",
    [registration]
  );

  const messageReady = useMemo(
    () =>
      registration
        ? isContextAgentAttentionMessageReady({
            agentName: registration.agentName,
            scopeLabel: registration.scopeLabel,
            scopeId: registration.scopeId,
            attentionMessage: registration.attentionMessage,
          })
        : false,
    [registration]
  );

  const handleOpenChat = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const bubble = useContextAgentAttentionBubble({
    scopeKey,
    open,
    messageReady,
    onOpenChat: handleOpenChat,
  });

  return { scopeKey, attentionMessage, ...bubble };
}
